import { Button } from '@mui/material'
import React, { useState, useRef, useEffect, useContext } from 'react'
// import CustomInput from '../../atoms/Inputs/CustomInput'
// import PrimaryButton from '../../atoms/PrimaryButton'
import { currencyFormat } from '@/custom/common/components'

const CartItem = (props) => {
    const [product, setProduct] = useState()

    useEffect(() => {
        setProduct(props.data)
    }, [props.data])

    return (
        <>
            {product ? (
                <>
                    <div className="cartItem d-flex justify-content-between align-items-start">
                        <div className="itemInfo d-flex justify-content-start">
                            <div className="pclImg">
                                <img
                                    src={`${global.images_url}${product.projects_avatar}`}
                                    alt={product.title}
                                />
                            </div>

                            <div className="listContent">
                                <div className="listLotInfo d-flex justify-content-start align-items-center">
                                    <h2 className="listProdTitle">
                                        {product.projects_title}
                                    </h2>
                                    {props.from === 'invoice' ? (
                                        <div className="badge badge-danger ml-3 px-2 py-1">
                                            {product.returned === 1
                                                ? 'Returned'
                                                : null}
                                        </div>
                                    ) : null}
                                </div>
                                {props.from == 'buynowcart' ||
                                props.from == 'buynowcheckout' ||
                                (props.from == 'invoice' &&
                                    product.buynow_autype === 'buynow') ? (
                                    <>
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>Amount:</span>
                                                <span>
                                                    {currencyFormat(
                                                        product.amount
                                                    )}
                                                </span>
                                            </h5>
                                            <h5>
                                                <span>Quantity:</span>{' '}
                                                <span>{product.qty}</span>
                                            </h5>
                                        </div>
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>Sub-total:</span>
                                                <span>
                                                    {currencyFormat(
                                                        product.per_total
                                                    )}
                                                </span>
                                            </h5>
                                            {props.from == 'invoice' &&
                                            product.buynow_autype ===
                                                'buynow' ? (
                                                <h5>
                                                    <span>
                                                        Delivery Status:
                                                    </span>
                                                    <span>
                                                        {product.delivered === 1
                                                            ? 'In Transit'
                                                            : product.delivered ===
                                                              2
                                                            ? 'Ready for Pickup'
                                                            : product.delivered ===
                                                              3
                                                            ? 'Completed'
                                                            : product.delivered ===
                                                              4
                                                            ? 'Cancelled'
                                                            : 'Pending'}
                                                    </span>
                                                </h5>
                                            ) : null}
                                        </div>
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>
                                                    Sales Tax (
                                                    {product.tax_percent}%):
                                                </span>
                                                <span>
                                                    {currencyFormat(
                                                        product.total_tax
                                                    )}
                                                </span>
                                            </h5>

                                            {product?.third_shipping_shipstation_confirmation ? (
                                                <h5>
                                                    <a
                                                        href={
                                                            product?.third_shipping_shipstation_confirmation
                                                        }
                                                        rel="noreferrer"
                                                        target="_blank"
                                                    >
                                                        Track Shipment
                                                    </a>
                                                </h5>
                                            ) : null}
                                        </div>
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>Total:</span>
                                                <span>
                                                    {currencyFormat(
                                                        product.total_amount
                                                    )}
                                                </span>
                                            </h5>
                                        </div>
                                    </>
                                ) : props.from == 'cart' ||
                                  props.from == 'checkout' ||
                                  (props.from == 'invoice' &&
                                      product.buynow_autype === 'auction') ||
                                  product.buynow_autype === 'live' ? (
                                    <>
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>Sub-total:</span>
                                                <span>
                                                    {currencyFormat(
                                                        product.per_total
                                                    )}
                                                </span>
                                            </h5>
                                            <h5>
                                                <span>Delivery Status:</span>
                                                <span>
                                                    {product.delivered === 1
                                                        ? 'In Transit'
                                                        : product.delivered ===
                                                          2
                                                        ? 'Ready for Pickup'
                                                        : product.delivered ===
                                                          3
                                                        ? 'Completed'
                                                        : product.delivered ===
                                                          4
                                                        ? 'Cancelled'
                                                        : 'Pending'}
                                                </span>
                                            </h5>
                                        </div>
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>
                                                    {props.taxLabel
                                                        ? `${props.taxLabel} :`
                                                        : `VAT (${product.tax_percent}%)`}
                                                </span>
                                                <span>
                                                    {currencyFormat(
                                                        product.total_tax
                                                    )}
                                                </span>
                                            </h5>
                                            {product?.third_shipping_shipstation_confirmation ? (
                                                <h5>
                                                    <a
                                                        href={
                                                            product?.third_shipping_shipstation_confirmation
                                                        }
                                                        rel="noreferrer"
                                                        target="_blank"
                                                    >
                                                        Track Shipment
                                                    </a>
                                                </h5>
                                            ) : null}
                                        </div>
                                        {product?.total_premium ? (
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>Buyer Premium:</span>
                                                    <span>
                                                        {currencyFormat(
                                                            product.total_premium
                                                        )}
                                                    </span>
                                                </h5>
                                            </div>
                                        ) : null}
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>Total:</span>
                                                <span>
                                                    {currencyFormat(
                                                        product.total_amount
                                                    )}
                                                </span>
                                            </h5>
                                        </div>
                                    </>
                                ) : null}
                                {props.changeAmount ? (
                                    <Button
                                        className="textTransformInitial noPrint"
                                        onClick={() =>
                                            props.changeAmount(
                                                product,
                                                'changeAmount'
                                            )
                                        }
                                    >
                                        <span className="material-icons">
                                            edit
                                        </span>
                                        {'Change Amount'}
                                    </Button>
                                ) : null}
                            </div>
                        </div>

                        <div className="listActBtn"></div>
                    </div>
                </>
            ) : null}
        </>
    )
}
export default CartItem
